// src/components/InstallPWA.jsx
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import usePWA from '../hooks/usePWA';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiX, FiZap, FiWifiOff } = FiIcons;

const InstallPWA = () => {
  const { installPrompt, isInstalled, isOnline, install } = usePWA();
  const [dismissed, setDismissed] = useState(false);
  const [showOffline, setShowOffline] = useState(!isOnline);

  // Offline banner
  if (!isOnline) return (
    <motion.div initial={{ y: -50 }} animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-[70] bg-red-600 text-white text-xs text-center py-2 flex items-center justify-center space-x-2">
      <SafeIcon icon={FiWifiOff} /><span>You are offline — some features may not work</span>
    </motion.div>
  );

  // Install banner
  if (!installPrompt || isInstalled || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-20 left-4 right-4 z-50 md:left-auto md:right-6 md:w-80">
        <div className="bg-gray-900 border border-blue-500/40 rounded-2xl p-4 shadow-2xl shadow-blue-500/10">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-xl flex items-center justify-center">
                <SafeIcon icon={FiZap} className="text-white" />
              </div>
              <div>
                <p className="text-white font-bold text-sm">Install App</p>
                <p className="text-gray-400 text-xs">Tayyab Electric Studio</p>
              </div>
            </div>
            <button onClick={() => setDismissed(true)} className="text-gray-600 hover:text-white">
              <SafeIcon icon={FiX} />
            </button>
          </div>
          <p className="text-gray-400 text-xs mb-3">Add to your home screen for quick access, offline support & notifications!</p>
          <div className="flex space-x-2">
            <button onClick={install}
              className="flex-1 flex items-center justify-center space-x-1 bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-xs font-bold py-2 rounded-xl">
              <SafeIcon icon={FiDownload} /><span>Install</span>
            </button>
            <button onClick={() => setDismissed(true)} className="flex-1 bg-gray-800 text-gray-400 text-xs py-2 rounded-xl">
              Not now
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InstallPWA;